import { IconButton, ThemeProvider, createTheme } from '@mui/material';
import './MobileHeroSection.css';
import { teal } from '@mui/material/colors';
import { FreeBreakfast, Instagram, Mail, X, Collections } from '@mui/icons-material';
import { motion, useAnimate, useMotionValueEvent, useScroll } from "framer-motion";
import { useEffect, useState } from "react";
import Banner from "../Banner";

const theme = createTheme({
    palette: {
        primary: {
            main: '#f9f0e8',
        },
        secondary: teal,
    },
    components: {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: "#f9f0e850"
                    }
                }
            }
        }
    }
})

const cloudImg = [
    {
        src: "/images/train/cloud.png",
        name: "cloud"
    }
]

const waterImg = [
    {
        src: "/images/train/water.png",
        name: "water"
    }
]

const pole1Img = [
    {
        src: "/images/train/poles1.png",
        name: "water"
    }
]

const pole2Img = [
    {
        src: "/images/train/poles2.png",
        name: "water"
    }
]

const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
}

export default function MobileHeroSection(props: {
    setImagesLoaded: React.Dispatch<React.SetStateAction<boolean>>;
}) {
    const [scope, animate] = useAnimate();
    const { scrollYProgress } = useScroll();
    const [hidden, setHidden] = useState(false);
    useMotionValueEvent(scrollYProgress, "change", (latest) => {
        latest > 0 ? setHidden(true) : setHidden(false);
    })

    async function bounceAnimation() {
        await animate(scope.current, { opacity: 0 });
        await animate(scope.current, { opacity: 1 }, { delay: 2 });
        animate(
            scope.current,
            {
                y: ["0%", "100%", "0%"]
            },
            {
                repeat: Infinity,
                ease: "easeInOut",
                duration: 2
            }
        )
    }

    useEffect(() => {
        bounceAnimation();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="mobile-hero-container">
            <img className="hero" src="/images/train/sky.png" alt="Hero Banner" onLoad={() => console.log("image loaded")} />
            <Banner images={waterImg} speed={10000} />
            <Banner images={cloudImg} speed={100000} />
            <Banner images={pole1Img} speed={900} />
            <Banner images={pole2Img} speed={950} />
            <div style={{ position: 'absolute', margin: "10% 0 0 0" }}>
                <img className="hero" src="/images/train/bannerBottom.png" alt="Hero Banner" />
            </div>

            <div style={{ position: 'absolute' }} >
                <img className="hero" src="/images/train/kart.png" alt="Hero Banner" />
            </div>

            <div className="mobile-hero-container" style={{ position: 'absolute' }}>
                <h1>hello</h1>
                <p>i'm oogy</p>
                <ThemeProvider theme={theme}>
                    <div className="container-side-by-side">
                        <IconButton href="https://twitter.com/spoogyoogie" target="_blank" aria-label="twitter" size="large" color="primary" style={{ cursor: "none" }}>
                            <X fontSize="large" />
                        </IconButton>
                        <IconButton href="https://www.instagram.com/spoogyoogie/" target="_blank" aria-label="instagram" size="large" color="primary" style={{ cursor: "none" }}>
                            <Instagram fontSize="large" />
                        </IconButton>
                        <IconButton href="https://ko-fi.com/spoogyoogie" target="_blank" aria-label="kofi" size="large" color="primary" style={{ cursor: "none" }}>
                            <FreeBreakfast fontSize="large" />
                        </IconButton>
                        <IconButton href="https://www.pixiv.net/en/users/32040454" target="_blank" aria-label="mail" size="large" color="primary" style={{ cursor: "none" }}>
                            <Collections fontSize="large" />
                        </IconButton>
                        <IconButton href="mailto:spoogyoogie@gmail.com" target="_blank" aria-label="mail" size="large" color="primary" style={{ cursor: "none" }}>
                            <Mail fontSize="large" />
                        </IconButton>
                    </div>
                </ThemeProvider>
            </div>

            <motion.div
                className="triangle-down-container"
                variants={variants}
                animate={hidden ? "hidden" : "visible"}
                transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.6 }}
            >
                <motion.div
                    ref={scope}
                    className='triangle-down'
                />
            </motion.div>
        </div>


    );
}